import { render, staticRenderFns } from "./Certificate.vue?vue&type=template&id=5e4f495b&scoped=true&"
import script from "./Certificate.vue?vue&type=script&lang=js&"
export * from "./Certificate.vue?vue&type=script&lang=js&"
import style0 from "./Certificate.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./Certificate.vue?vue&type=style&index=1&id=5e4f495b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e4f495b",
  null
  
)

export default component.exports